import dayjs, { Dayjs } from "dayjs";
import isoWeek from "dayjs/plugin/isoWeek";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(isoWeek);
dayjs.extend(relativeTime);

export const formatToDefault = "YYYY-MM-DD";

export const formats = {
  DEFAULT: "D MMM YYYY",
  DATE_FORMAT_1: "DD MMM YYYY",
  WITH_TIME: "D MMM YYYY h:mm A",
  DATE_MONTH: "DD MMM",
  D_MMM: "D MMM",
  MONTH: "M",
  YEAR: "YYY",
  TIME: "h:mm A",
};

// export const formatYearMonth = (yearMonth: string, format: string) => {
//   return dayjs(yearMonth, "YYYYMM").format(format);
// };

// export const formatMonth = (month: number, format: string) => {
//   return dayjs()
//     .month(month - 1)
//     .format(format);
// };

// export const getTimeFromString = (
//   time: string,
//   format: string = "HH:mm:ss"
// ) => {
//   return dayjs(time, format);
// };
// export const formatTime = (time: Dayjs, formatString: string = "HH:mm:ss") => {
//   return time.format(formatString);
// };

export function getCustomFormattedDate(
  date: string | Dayjs | Date,
  formatString: string
) {
  return dayjs(date).format(formatString);
}

// export function getFormattedDate(
//   date: string | Dayjs | Date | undefined,
//   type?: keyof typeof formats
// ) {
//   if (date) {
//     return getCustomFormattedDate(date, formats[type ?? "DEFAULT"]);
//   }
// }

// export const getFormattedTime = (date: string | undefined) => {
//   if (date) {
//     return dayjs(date).format("h:mm a");
//   }
// };

// type FormatOptions = {
//   dateFormatType?: string;
//   timeFormatType?: string;
// };
// const defaultFormat: FormatOptions = {
//   dateFormatType: "D MMM YYYY",
//   timeFormatType: "hh:mm A",
// };
// export const getDateTimeArray = (date: string, options?: FormatOptions) => {
//   const dayjsDate = dayjs(date),
//     formatOptions = { ...defaultFormat, ...options };

//   return [
//     dayjsDate.format(formatOptions.dateFormatType),
//     dayjsDate.format(formatOptions.timeFormatType),
//   ];
// };

// export const isPastDate = (date: string) => {
//   return dayjs(date).diff(dayjs(), "hours") < 0;
// };

// export const getRelativeDaysFromNow = (date: string) => {
//   return dayjs().to(dayjs(date));
// };

// export const getCurrentDate = (format?: string) => {
//   const formatToUse = format ?? "DD MMM YYYY";

//   return dayjs().format(formatToUse);
// };

// export const getDateObj = (date: string | Dayjs) => dayjs(date);

// export const getCurrentMonthYear = (format?: string) => {
//   const formatToUse = format ?? "MMM YYYY";

//   return dayjs().format(formatToUse);
// };

// export const getCurrentMonth = (format?: string) => {
//   const formatToUse = format ?? "M";

//   return dayjs().format(formatToUse);
// };

// export const getCurrentYear = (format?: string) => {
//   const formatToUse = format ?? "YYYY";

//   return dayjs().format(formatToUse);
// };

// export const getDateStringForRequestPayload = (
//   date?: string | Date | Dayjs
// ) => {
//   return date ? dayjs(date).format(formatToDefault) : undefined;
// };
// export function monthYearText(monthYear: number) {
//   return dayjs(monthYear.toString(), "YYYYMM").format("MMM YYYY");
// }

// export const TWO_MINUTES = Date.now() + 1000 * 120;
// export const TEN_MINUTES = Date.now() + 1000 * 600;
// export const SIX_MINUTES = Date.now() + 1000 * 600;
